import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {toCurrency} from 'utils/number';

type PriceCalculationProps = {
    isError: boolean;
    isInvalid?: boolean;
    isLoading: boolean;
    isSuccess: boolean;
    value?: number;
};

const PriceCalculation: FC<PriceCalculationProps> = ({
    isError = false,
    isInvalid = false,
    isLoading = false,
    isSuccess = false,
    value,
}) => {
    const {t} = useTranslation('Billing.PlanChange');

    return isInvalid ? (
        <div className="p-3 text-center text-green-800">---</div>
    ) : isLoading ? (
        <div className="p-3 text-center text-green-800" role="progressbar">
            {t('shared.loading')}
        </div>
    ) : isError ? (
        <div
            aria-label="server error"
            className="border-gold-200 bg-gold-50 p-3 text-center text-light-primary"
            role="alert"
        >
            {t('shared.error')}
        </div>
    ) : isSuccess && value ? (
        <div className="p-3 text-center text-green-800">
            {t('shared.plusTax', {
                value: toCurrency({
                    currency: 'JPY',
                    value,
                }),
            })}
        </div>
    ) : (
        <div className="p-3 text-center text-green-800">---</div>
    );
};

export default PriceCalculation;
